import React, { useRef } from "react";

import classNames from "classnames/bind";
import UIIcon from "common/blocks/UIIcon";
import useModalContext from "common/providers/modal/useModalContext";
import ReactDOM from "react-dom";

import IconButton from "../IconButton";
import styles from "./Toast.module.scss";

const cx = classNames.bind(styles);

const Toast = () => {
    const { useToast } = useModalContext();
    const { toast, closeToast, toastContent } = useToast();
    const toastRef = useRef<HTMLDivElement>(null);

    const toastElement: HTMLDivElement | null =
        typeof document !== "undefined"
            ? (document.querySelector("#toast-root") as HTMLDivElement)
            : null;

    const ContentComponent = toastContent?.content?.component ?? null;

    if (toast && toastElement) {
        const TitleIcon = toastContent?.titleIcon ? (
            React.isValidElement(toastContent?.titleIcon) ? (
                toastContent.titleIcon
            ) : (
                <UIIcon {...toastContent.titleIcon} className={cx("icon")} />
            )
        ) : null;

        return (
            <>
                {ReactDOM.createPortal(
                    <>
                        <div className={cx("mask")} />
                        <div className={cx("toast")} ref={toastRef}>
                            <IconButton
                                onClick={closeToast}
                                title="Close Notification"
                                aria-label="Close Notification"
                                icon="Close"
                                className={cx("closeButton")}
                            />

                            <div className={cx("content")}>
                                <div className={cx("iconWrapper")}>{TitleIcon}</div>
                                <span className={cx("title")}>{toastContent?.title ?? ""}</span>

                                <ContentComponent {...(toastContent?.content?.props || {})} />
                            </div>
                        </div>
                    </>,
                    toastElement
                )}
            </>
        );
    }

    return null;
};

export default Toast;
